<template>
  <a-plane
    :src="cdn(require('./img/skip.png'))"
    transparent="true"
    :width="size || .05"
    :height="size || .05"
    ref="skip"
    class="Fuse"
    material="shader: flat; depthTest: false"
    scale="1 1 1"
    @click="click"
    opacity="0"
    @materialtextureloaded="show"
  />
</template>

<script>
export default {
  name: 'Skip',
  props: ['size'],
  data: () => ({
    canClick: true,
  }),
  methods: {
    click() {
      if(!this.canClick) return
      this.next()
      this.canClick = false
      setTimeout(() => this.canClick = true, 3500)
    },
    show() {
      TweenLite.to(this.$el, 1, { aframe: { alpha: 1 } })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/skip/Skip.vue